import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Feedback } from '../feedback/feedback';

const OPPORTUNITIES_API_URL = '/api/v2/opportunities';
const opportunityHostFeedbackUrl = (opportunityId: string) =>
  `${OPPORTUNITIES_API_URL}/${opportunityId}/feedback/host`;
const opportunityHostPrepFeedbackUrl = (opportunityId: string) =>
  `${OPPORTUNITIES_API_URL}/${opportunityId}/feedback/host-prep`;
const opportunityParticipantFeedbackUrl = (opportunityId: string) =>
  `${OPPORTUNITIES_API_URL}/${opportunityId}/feedback/participant`;

@Injectable({ providedIn: 'root' })
export class OpportunitiesBackend {
  constructor(private http: HttpClient) {}

  getFeedbackHost(opportunityId: string) {
    return this.http.get(opportunityHostFeedbackUrl(opportunityId));
  }

  getFeedbackParticipant(opportunityId: string) {
    return this.http.get(opportunityParticipantFeedbackUrl(opportunityId));
  }

  postFeedbackHost(opportunityId: string, feedback: Feedback) {
    return this.http.post(opportunityHostFeedbackUrl(opportunityId), feedback);
  }

  postFeedbackHostPrep(opportunityId: string, feedback: Feedback) {
    return this.http.post(
      opportunityHostPrepFeedbackUrl(opportunityId),
      feedback,
    );
  }

  postFeedbackParticipant(opportunityId: string, feedback: Feedback) {
    return this.http.post(
      opportunityParticipantFeedbackUrl(opportunityId),
      feedback,
    );
  }
}
